export type DeviceMetricSender = (
  metric: string,
  payload?: Record<string, unknown>,
) => void;

export function emitPlaybackFailed(
  send: DeviceMetricSender | undefined,
  detail: Record<string, unknown>,
): void {
  send?.("playback.failed", detail);
}

export function emitPlaybackStalled(
  send: DeviceMetricSender | undefined,
  detail: Record<string, unknown>,
): void {
  send?.("playback.stalled", detail);
}

export function emitCrossfadeFallback(
  send: DeviceMetricSender | undefined,
  reason: string,
): void {
  send?.("audio.crossfade_fallback", { reason });
}
